import MarkAttendanceDayView from './component';
import _routes from './routes';

export const routes = _routes;

export default MarkAttendanceDayView;



// WEBPACK FOOTER //
// ./containers/Group/Attendance/MarkAttendance/MarkAttendanceDayView/index.jsx